module.exports = __webpack_public_path__ + "img/MASTER_CHN_VP_Handbook_Web18.5bd2fb90.jpg";